import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";
import {gsap} from "../LibrariesImport";

export default class NavsFull {
    static init() {
        this.header = document.querySelector(".header-main-full");

        if (this.header) {
            this.overlay = this.header.querySelector(".overlay");
            this.navBg = this.header.querySelector(".nav-main-bg");
            this.toggleMobileNav();
            this.initMegaMenu();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    static toggleMobileNav() {
        const openTrigger = document.querySelector(".nav-main-toggle");
        if (openTrigger) {
            openTrigger.addEventListener("click", () => {
                if (document.body.classList.contains("navs-open")) {
                    this.closeMobileNav();
                } else {
                    this.openMobileNav();
                }
            });
        }
    }

    static openMobileNav() {
        document.body.classList.add("navs-open");
        Header.makeHeaderAsBannerTheme();
        GlobalVariables.lenis?.stop();
    }

    static closeMobileNav() {
        document.body.classList.remove("navs-open");
        Header.restoreHeaderTheme();

        const activeMenuItems = this.header.querySelectorAll(".is-active");
        activeMenuItems.forEach(item => {
            item.classList.remove("is-active");
        });

        GlobalVariables.lenis?.start();
    }

    static initMegaMenu() {
        // Un clic sur l'overlay ferme tout
        this.overlay.addEventListener("click", () => {
            this.restoreNav();
        });

        this.adjustNavHeight();
        this.navMain = this.header.querySelector(".nav-main");
        this.levelOneItems = this.navMain.querySelectorAll(".menu-item-lev1.menu-item-has-children");

        this.levelOneItems.forEach(levelOne => {
            levelOne.toggle = levelOne.querySelector("button[data-header='toggler']");
            levelOne.subNav = levelOne.querySelector(".nav-main-subnav");

            if (!levelOne.subNav) {
                return;
            }

            const toggle = levelOne.querySelectorAll("button[data-header='toggler']");
            toggle.forEach( btn => {
                btn.addEventListener("click", (e) => {

                    e.preventDefault();
                    const parent = btn.closest('li');

                    document.body.classList.remove('banner-subnav-is-open');
                    document.body.classList.add('navs-open');

                    if (parent.classList.contains('menu-item-lev2')) {
                        let elActive = levelOne.querySelectorAll(".is-active");
                        elActive.forEach(el => {
                            el.classList.remove('is-active');
                        });
                    }

                    if(parent) {
                        const itemActive = btn.closest('ul').querySelector("& > .is-active");
                        if( !parent.classList.contains('is-active') ){
                            if(itemActive){
                                itemActive.classList.remove('is-active');
                            }
                        }
                        parent.classList.toggle('is-active');
                    }

                    if (window.innerWidth > 991) {
                        this.adjustNavHeight();
                        if( this.navMain.querySelector('.menu-item-lev1.is-active') ){
                            GlobalVariables.lenis?.stop();
                        } else {
                            GlobalVariables.lenis?.start();
                        }
                    }
                });

            });

            const toggleBack = levelOne.querySelectorAll("button[data-header='toggler-back']");
            toggleBack.forEach( btn => {
                btn.addEventListener("click", (e) => {
                    e.preventDefault();
                    const parent = btn.closest('.is-active');
                    if(parent){
                        parent.classList.remove('is-active');
                    }
                });
            });

        });
    }

    static closeAllLev2() {
        this.levelOneItems.forEach(item => {
            item.classList.remove("is-active");
            item.querySelector("button[data-header='toggler']").setAttribute("aria-expanded", "false");
        });

        if (window.innerWidth > 991) {
            GlobalVariables.lenis?.start();
        }
    }

    static restoreNav() {
        this.closeMobileNav();
        this.adjustNavHeight();
    }

    static adjustNavHeight(){
        const subNavContainer = this.header.querySelectorAll('.nav-main-subnav');
        subNavContainer.forEach( nav => {
            nav.style.height = "auto";
            if (window.innerWidth > 991) {
                const lev2 = nav.querySelector('.lev2-items');
                const lev3 = nav.querySelectorAll('.lev3-items');
                const padding = window.getComputedStyle(nav).paddingTop;
                let height = lev2.offsetHeight;

                const lev2Active = lev2.querySelector('li.is-active');
                if( !lev2Active ){
                    lev2.querySelector('li.d-lg-none + li').classList.add('is-active');
                }
                lev3.forEach( (lev,i )  =>{
                    if(lev.offsetHeight > height){
                        height = lev.offsetHeight;
                    }
                });
                nav.style.height = (height + parseFloat(padding) * 2) +"px";
            }else{
                nav.style.height = "100svh";
            }
        });
    }

    static adjustNavBg(levelTwo) {
        if (window.innerWidth > 991) {
            const navBg = this.header.querySelector(".nav-main .nav-main-bg");
            gsap.to(navBg, {duration: 0.3, height: levelTwo.offsetHeight});
        }
    }

    static resize() {
        this.restoreNav();
    }
}